var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_edit",
    "data-name": "vuesax/bulk/edit",
    transform: "translate(-620 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.48,0H5.52C2.07,0,0,2.06,0,5.52v7.95C0,16.94,2.07,19,5.52,19h7.95c3.46,0,5.52-2.06,5.52-5.52V5.52C19,2.06,16.93,0,13.48,0Z",
    transform: "translate(622 255)",
    fill: "#908fa2",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M6.617,1.365c-1.79-1.8-3.54-1.84-5.38,0L.107,2.485a.365.365,0,0,0-.09.37,7.5,7.5,0,0,0,5.11,5.11.41.41,0,0,0,.11.01.386.386,0,0,0,.27-.11l1.11-1.12a3.843,3.843,0,0,0,1.36-2.67A3.922,3.922,0,0,0,6.617,1.365Z",
    transform: "translate(634.403 253.615)",
    fill: "#908fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M11.174,5.08a7.993,7.993,0,0,1-.77-.41c-.2-.12-.4-.25-.59-.39a5.219,5.219,0,0,1-.52-.4,1.028,1.028,0,0,1-.16-.14,7.2,7.2,0,0,1-.95-.96.766.766,0,0,1-.13-.17,3.734,3.734,0,0,1-.38-.51,4.786,4.786,0,0,1-.36-.55,7.885,7.885,0,0,1-.4-.76c-.13-.28-.23-.54-.32-.79L1.214,5.38a3.07,3.07,0,0,0-.76,1.5L.024,9.86a1.872,1.872,0,0,0,.47,1.61,1.773,1.773,0,0,0,1.28.5c.11,0,.22-.01.33-.02l2.97-.42a2.988,2.988,0,0,0,1.5-.76l5.38-5.38C11.7,5.31,11.454,5.2,11.174,5.08Z",
    transform: "translate(626.686 257.34)",
    fill: "#908fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(620 252)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cc93fc16f373b0759c3a3b499ce1f97f.svg";
export { ForwardRef as ReactComponent };